import React from 'react';
import { AddingUserOptions } from '../constants';
import styles from '../styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
/**
 * @typedef {object} SingleOrMultiUserlProps
 * @property {*} [onUserAddOptionSelected]
 */

export const SingleOrMultiUser = (props) => {
    function handleOnSelect(selection) {
        return () => {
            if (props.onUserAddOptionSelected) {
                props.onUserAddOptionSelected(selection);
            }
        };
    }

    return (
        <div>
            <button className={styles.addUserSelectionBtn} onClick={handleOnSelect(AddingUserOptions.single)}>
                <FontAwesomeIcon icon={faUser} className={styles.iconSize} />
                Add a single user
            </button>
            <button className={styles.addUserSelectionBtn} onClick={handleOnSelect(AddingUserOptions.multiple)}>
                <FontAwesomeIcon icon={faUsers} className={styles.iconSize} />
                Add multiple users
            </button>
        </div>
    );

};
